import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5
  },
  price: {
    fontFamily: 'var(--font-mono)',
    fontSize: 13,
    color: 'var(--ink)'
  },
  best: {
    fontFamily: 'var(--font-mono)',
    fontSize: 13,
    fontWeight: 600,
    color: 'var(--material)',
    background: 'var(--material-soft)',
    borderRadius: 4,
    padding: '2px 6px'
  },
  noPrice: {
    fontFamily: 'var(--font-mono)',
    fontSize: 13,
    color: 'var(--ink-4)'
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flexShrink: 0
  },
  dotInStock: {
    backgroundColor: 'var(--ok)'
  },
  dotOutOfStock: {
    backgroundColor: 'var(--risk)'
  },
  dotUnknown: {
    backgroundColor: 'var(--ink-4)'
  }
}))

export default function SupplierPriceCell ({ price, unit, isBest, availabilityStatus }) {
  const classes = useStyles()

  const dotClass = availabilityStatus === 'IN_STOCK'
    ? classes.dotInStock
    : availabilityStatus === 'OUT_OF_STOCK'
      ? classes.dotOutOfStock
      : classes.dotUnknown

  if (price == null) {
    return (
      <span className={classes.root}>
        <span className={classes.noPrice}>{'\u2014'}</span>
        <span className={`${classes.dot} ${dotClass}`} />
      </span>
    )
  }

  const formatted = `$${Number(price).toFixed(2)}/${(unit || 'ton').toLowerCase()}`

  return (
    <span className={classes.root}>
      <span className={isBest ? classes.best : classes.price}>{formatted}</span>
      <span className={`${classes.dot} ${dotClass}`} />
    </span>
  )
}
